"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveySection = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SurveySection = function SurveySection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-survey-section card mb-[50px] p-[24px] shadow-5 border-none flex flex-col gap-y-[16px]"
  }, children);
};
exports.SurveySection = SurveySection;